import Vue from "vue";
import Vuex from "vuex";
import { createStore } from "vuex-extensions";
import category from "./categories";
import recipes from "./recipes";
import user from "./user";

Vue.use(Vuex);

export default createStore(Vuex.Store, {
  modules: {
    category,
    recipes,
    user
  }
});
